var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHint = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 10,
  viewBox: "0 0 12 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.43225 1.75766e-05H9.56773C10.6304 1.75766e-05 11.5 0.82361 11.5 1.82999V5.99946C11.5 7.00584 10.6304 7.82943 9.56773 7.82943L5.02715 7.82994L2.84631 9.89533C2.7773 9.96068 2.68079 10 2.57027 10C2.51527 10 2.47376 9.98672 2.41822 9.97396C2.2802 9.92188 2.1837 9.77789 2.1837 9.6339V7.8034C1.23159 7.68596 0.5 6.91445 0.5 5.99944V1.82997C0.514017 0.823593 1.36963 0 2.43227 0L2.43225 1.75766e-05ZM5.68979 5.62065C5.7588 5.69928 5.8553 5.72532 5.9518 5.72532C6.06233 5.72532 6.15883 5.68601 6.22784 5.62065C6.28284 5.5553 6.32435 5.47666 6.32435 5.37251C6.32435 5.28111 6.28284 5.18972 6.21383 5.12436C6.07581 4.99365 5.82726 4.99365 5.68924 5.12436C5.62023 5.18972 5.57872 5.28111 5.57872 5.37251C5.57926 5.47718 5.62077 5.5553 5.68978 5.62065H5.68979ZM5.57926 3.93472C5.57926 4.13079 5.74478 4.28754 5.95181 4.28754C6.15884 4.28754 6.32435 4.13079 6.32435 3.93472V2.07874C6.32435 1.88267 6.15884 1.72592 5.95181 1.72592C5.74478 1.72592 5.57926 1.88267 5.57926 2.07874V3.93472Z",
  fill: "#3F535D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hint.915d36afe4cbcdf1ab401b7aa8fe0081.svg";